<app-layout-auth [isGuest]="false">
  <img id="logo" src="./assets/svg/logo-update-password.svg" alt="logo" />
  <h1>{{'update-password.title'|translate}}</h1>
  <form [formGroup]="formUpdatePassword" (ngSubmit)="updatePassword()" novalidate>
    <!-- Old Password -->
    <app-input-password
      class="input-group-container"
      [formControlNameInput]="'oldPassword'"
      [placeHolderInput]="'update-password.old_password'|translate"
      [ngClass]="{
        'is-invalid': (submitted || f['oldPassword'].touched) && f['oldPassword'].invalid,
        'is-valid': f['oldPassword'].touched && f['oldPassword'].valid
      }"
      [submitted]="submitted"
      [formPassword]="f['oldPassword']"
    ></app-input-password>

    <!-- New Password -->
    <app-input-password
      class="input-group-container"
      [formControlNameInput]="'password'"
      [placeHolderInput]="'update-password.new_password'|translate"
      [ngClass]="{
        'is-invalid': (submitted || f['password'].touched) && f['password'].invalid,
        'is-valid': f['password'].touched && f['password'].valid
      }"
      [submitted]="submitted"
      [formPassword]="f['password']"
    ></app-input-password>

    <!-- Confirm Password -->
    <app-input-password
      class="input-group-container"
      [formControlNameInput]="'confirmPassword'"
      [placeHolderInput]="'update-password.re_password'|translate"
      [ngClass]="{
        'is-invalid': (submitted || f['confirmPassword'].touched) && formUpdatePassword.errors,
        'is-valid': f['confirmPassword'].touched && !formUpdatePassword.errors
      }"
    ></app-input-password>
    <c-form-feedback *ngIf="(submitted || f['confirmPassword'].touched) && formUpdatePassword.errors">
      <div *ngIf="formUpdatePassword.errors['passwordMismatch']">
        {{ 'errorMessages.confirmPassword.passwordMismatch'|translate }}
      </div>
    </c-form-feedback>
    <button cButton [disabled]="loading" type="submit">{{'update-password.btn_update'|translate}}</button>
  </form>
</app-layout-auth>
